import { Injectable, signal } from '@angular/core';

/**
 * Set by `reSlidingTabs` once sibling tab pages are mounted (or preload is skipped).
 * Home defers the credits card until this is true so wallet UI does not race tab warming.
 */
@Injectable()
export class MainTabsPreloadService {
  private readonly _ready = signal(false);

  /** True when tab pager preload finished or was not needed. */
  readonly ready = this._ready.asReadonly();

  markReady(): void {
    this._ready.set(true);
  }
}
